const SortDescending = () => (
  <>
    <path
      fill="currentColor"
      d="M11.5 7a.5.5 0 1 0 0 1h1.75a.5.5 0 0 0 0-1zm0 4.5a.5.5 0 1 0 0 1h5.366a.5.5 0 0 0 0-1zm0 4.5a.5.5 0 1 0 0 1h9a.5.5 0 0 0 0-1zM6.616 7.56l1.078 1.077q.13.14.327.14a.48.48 0 0 0 .345-.146.46.46 0 0 0 .137-.34.47.47 0 0 0-.14-.348l-1.681-1.7A.78.78 0 0 0 6.116 6a.78.78 0 0 0-.565.242l-1.7 1.7a.464.464 0 0 0 0 .674q.133.137.34.137a.47.47 0 0 0 .348-.14L5.616 7.56v9.94q0 .212.144.356a.49.49 0 0 0 .357.144q.213 0 .356-.144a.48.48 0 0 0 .143-.356z"
    />
  </>
)
export default SortDescending
